import { ProFormSlider } from '@ant-design/pro-components'
import type React from 'react'
import { EditableLabel } from '../components/EditableLabel'
import { EditableShell } from '../components/EditableShell'
import { useFieldContext } from '../createAppFormHook'
import { useEditableFieldMode } from '../hooks/useEditableFieldMode'
import { useMergedFieldProps } from '../utils/mergeFieldProps'

export type SliderFieldProps = React.ComponentProps<typeof ProFormSlider>

export function SliderField(props: SliderFieldProps) {
  const fieldCtx = useFieldContext<number | [number, number] | undefined>()
  const { formItemProps, fieldProps, proFieldProps, className, ...rest } = props

  const editable = useEditableFieldMode<number | [number, number] | undefined>()

  const merged = useMergedFieldProps({
    fieldCtx,
    editable,
    props,
    fieldDefaults: {
      fieldProps: {
        onChange: (val: number | [number, number]) => {
          fieldCtx.handleChange(val)
        },
      },
    },
  })

  return (
    <EditableShell
      mode={editable.mode}
      enterEdit={editable.enterEdit}
      exitRead={editable.exitRead}
      className={className}
    >
      <ProFormSlider
        {...rest}
        label={
          <EditableLabel
            mode={editable.mode}
            enterEdit={editable.enterEdit}
            exitRead={editable.exitRead}
            onUndo={editable.undoAndExit}
            canUndo={editable.canUndo}
          >
            {rest.label}
          </EditableLabel>
        }
        proFieldProps={merged.proFieldProps}
        formItemProps={merged.formItemProps}
        fieldProps={merged.fieldProps}
      />
    </EditableShell>
  )
}
